import { CustomPayRunType, RUN_DISCARDED, RUN_WITHDRAWN, type CustomPayRunResponse } from '../types';

/** A run that has been handed to Payroll Review is final for this module; everything else can still be worked on. */
const HANDED_OFF_STATUS = 'HandedOffToPayrollReview';

/** The newest open run (regular by default, or of any type) that was not handed off to Payroll Review, discarded or withdrawn, or null. */
export function findResumableRun(runs: CustomPayRunResponse[], runType: number | 'any' = CustomPayRunType.Regular): CustomPayRunResponse | null {
  const open = runs
    .filter((r) => (runType === 'any' || r.runType === runType) && r.status !== HANDED_OFF_STATUS && r.status !== RUN_DISCARDED && r.status !== RUN_WITHDRAWN)
    .sort((a, b) => b.updatedAtUtc.localeCompare(a.updatedAtUtc));
  return open[0] ?? null;
}
